import React from "react";
import "./index.scss";

export interface TabBarItemInterface {
  label: string;
  isAccess?: boolean;
  // Phase 42: mirrors TabBar's own children[].props.badge -- read by TabBar directly off this
  // element's props, not by TabBarItem itself (same as actionButtonTitle/actionButtonOnClick below).
  badge?: number;
  children: React.ReactNode;
  actionButtonTitle?: string;
  actionButtonOnClick?: () => void;
  // Consumers pass these props ON TabBarItem, not on TabBar itself — this must mirror the field
  // TabBar's own children[].props shape declares (TabBar.tsx), or a consumer passing
  // actionButtonClassName here is a TypeScript excess-property error.
  actionButtonClassName?: string;
}

const TabBarItem: React.FC<TabBarItemInterface> = (props) => {
  const { children } = props;

  return <div className="tab-bar-item">{children}</div>;
};

export default TabBarItem;
